import React, { useEffect, useMemo, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "../assets/css/Projects.css";
import "../assets/css/ViewCustomer.css";
import IssueDetailsPanel from "./issues/IssueDetailsPanel";
import { fetchIssueById } from "./issues/issueService";
import { canPerformActionOnPage, PAGES, ACTIONS } from "../utils/roleAccess";

function ViewIssue() {
  const navigate = useNavigate();
  const routerLocation = useLocation();
  const { issueId } = useParams();
  const role = useMemo(() => {
    try {
      const u = localStorage.getItem("user");
      if (!u) return null;
      const user = JSON.parse(u);
      const primaryRole = Array.isArray(user.roles) && user.roles.length > 0 ? user.roles[0] : null;
      return (
        (primaryRole && (primaryRole.role_name || primaryRole.name || primaryRole.role)) ||
        user.role_name ||
        user.role ||
        null
      );
    } catch {
      return null;
    }
  }, []);
  const canEdit = canPerformActionOnPage(PAGES.ISSUES, ACTIONS.EDIT, role);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [issue, setIssue] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError("");
      try {
        const data = await fetchIssueById(issueId);
        if (!data) {
          setError("Issue not found.");
          setIssue(null);
        } else {
          setIssue(data);
        }
      } catch (err) {
        console.error("Error fetching issue:", err);
        setError(err.response?.data?.message || err.response?.data?.error || "Failed to load issue.");
        setIssue(null);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [issueId, routerLocation.pathname, routerLocation.key]);

  return (
    <div className="viewlead-container">
      <div className="viewlead-header">
        <button type="button" className="viewlead-back-link" onClick={() => navigate("/issues")}>
          <FaArrowLeft /> Back to Issues
        </button>
        {canEdit ? (
          <button
            type="button"
            className="btn-subproject-primary"
            onClick={() => navigate(`/issues/${issueId}/edit`)}
          >
            Edit Issue
          </button>
        ) : null}
      </div>

      {loading ? (
        <div className="viewlead-loading">Loading issue...</div>
      ) : error ? (
        <div className="error-message" style={{ backgroundColor: "#fee", color: "#c33", padding: "12px", borderRadius: "4px", marginBottom: "20px", fontSize: "14px" }}>
          {error}
        </div>
      ) : (
        <IssueDetailsPanel
          issue={issue}
          issueId={issueId}
          canEdit={canEdit}
          onUpdated={async (updated) => {
            try {
              const fresh = await fetchIssueById(issueId);
              if (fresh) setIssue(fresh);
              else if (updated) setIssue(updated);
            } catch (e) {
              console.error("Error refetching issue:", e);
              if (updated) setIssue(updated);
            }
          }}
        />
      )}
    </div>
  );
}

export default ViewIssue;


